import dayjs from "dayjs";
import ReactDOMServer from "react-dom/server";

import { pureNumberFilter } from "app/filters/numberFilter";
import { CommonChangeOverTimeChartTooltipContent } from "app/pages/website-analysis/incoming-traffic/commonOverTime";
import { getChange } from "app/pages/website-analysis/incoming-traffic/getChange";
import { TrafficOverTimeChartToolTip } from "app/pages/website-analysis/incoming-traffic/StyledComponents";

export default {
    tooltip: {
        formatter() {
            const currentIndex = this.series.data.findIndex((p) => p.index === this.point.index);
            const isFirstItem = currentIndex === this.series.data.length - 1;
            const prevPoint = !isFirstItem && this.series.data[currentIndex + 1];
            const change = getChange(prevPoint.y, this.y);
            const dateForTitle = dayjs.utc(this.x).utc().format("MMM YYYY");

            return ReactDOMServer.renderToString(
                <TrafficOverTimeChartToolTip>
                    <strong>Search Volume - {dateForTitle}</strong>
                    <CommonChangeOverTimeChartTooltipContent
                        valueFormatted={pureNumberFilter(this.y)}
                        isFirstItem={isFirstItem}
                        change={change}
                        showNoChangeSymbol
                    />
                </TrafficOverTimeChartToolTip>,
            );
        },
    },
};
